import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/ga-east-logo.jpg'
import _imports_1 from '../assets/coat_of_arms.png'


const _withScopeId = n => (_pushScopeId("data-v-2c9cd806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-component w-full z-50 fixed top-0 left-0 right-0" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-[#1E2833] text-white text-xs\" data-v-2c9cd806><div class=\"container mx-auto px-4 sm:px-6 flex items-center justify-between py-2\" data-v-2c9cd806><div class=\"hidden sm:flex items-center space-x-4\" data-v-2c9cd806><a href=\"tel:0302962718\" class=\"flex items-center gap-1.5 text-gray-300 hover:text-[#6CC551] transition-colors\" data-v-2c9cd806><svg class=\"w-3.5 h-3.5 flex-shrink-0\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-2c9cd806><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z\" data-v-2c9cd806></path></svg> 0302-962718 </a><span class=\"text-gray-600\" data-v-2c9cd806>|</span><a href=\"mailto:info@gema.gov.gh\" class=\"flex items-center gap-1.5 text-gray-300 hover:text-[#6CC551] transition-colors\" data-v-2c9cd806><svg class=\"w-3.5 h-3.5 flex-shrink-0\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-2c9cd806><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z\" data-v-2c9cd806></path></svg> info@gema.gov.gh </a></div><div class=\"flex items-center gap-3 ml-auto\" data-v-2c9cd806><a href=\"https://www.facebook.com/gema.abokobi\" target=\"_blank\" rel=\"noreferrer\" aria-label=\"Facebook\" class=\"text-gray-300 hover:text-[#6CC551] transition-colors\" data-v-2c9cd806><svg class=\"w-4 h-4\" fill=\"currentColor\" viewBox=\"0 0 24 24\" data-v-2c9cd806><path fill-rule=\"evenodd\" d=\"M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z\" clip-rule=\"evenodd\" data-v-2c9cd806></path></svg></a><a href=\"http://outlook.office365.com/\" target=\"_blank\" class=\"px-3 py-1 bg-[#6CC551] text-white font-medium rounded hover:bg-green-600 transition-colors\" data-v-2c9cd806> Staff Mail </a></div></div></div>", 1)
const _hoisted_3 = { class: "container mx-auto px-4 sm:px-6 flex items-center justify-between py-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-10 sm:h-12 w-auto",
  alt: "Ga East Logo"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hidden lg:block text-sm font-bold text-[#3a3838] uppercase leading-snug tracking-wide" }, [
    /*#__PURE__*/_createTextVNode(" Ga East Municipal"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Assembly ")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "lg:hidden text-lg font-bold text-[#3a3838] uppercase tracking-wide" }, "GEMA")
], -1))
const _hoisted_6 = { class: "hidden md:flex items-center" }
const _hoisted_7 = ["onMouseenter"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "absolute top-full left-0 mt-1 min-w-[220px] max-h-72 overflow-y-auto bg-[#1E2833] shadow-2xl z-50"
}
const _hoisted_11 = { class: "px-4 py-2 border-b border-white/10 flex items-center gap-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-1 h-3.5 bg-[#6CC551] rounded-full flex-shrink-0" }, null, -1))
const _hoisted_13 = { class: "text-[10px] font-bold uppercase tracking-widest text-gray-400 text-left" }
const _hoisted_14 = { class: "py-1" }
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "hidden sm:block h-12 w-auto",
  alt: "Coat of Arms"
}, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 6h16M4 12h16M4 18h16"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "md:hidden border-t border-gray-200 bg-white"
}
const _hoisted_24 = { class: "px-4 py-3 space-y-1" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
  "clip-rule": "evenodd"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "mt-1 mb-2 bg-[#1E2833] rounded-lg overflow-hidden"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://outlook.office365.com/",
  target: "_blank",
  class: "block px-3 py-2.5 text-sm font-medium text-white bg-[#6CC551] rounded-lg hover:bg-green-600 uppercase tracking-wide transition-colors text-center mt-2"
}, " Staff Mail ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar-spacer" }, null, -1))

import { onMounted, onUnmounted, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { url } from "@/functions/endpoint";
import { encryptString } from "@/functions/encryption";
import axios from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const route = useRoute();
const isScrolled = ref(false);
const handleScroll = () => { isScrolled.value = window.scrollY > 10; };

const activeDropdown = ref<string | null>(null);
const mobileOpen = ref(false);
const mobileAccordion = ref<string | null>(null);

const toggleMobileAccordion = (name: string) => {
  mobileAccordion.value = mobileAccordion.value === name ? null : name;
};

const closeMobileNav = () => {
  mobileOpen.value = false;
  mobileAccordion.value = null;
};

const allDepartments = ref<any[]>([]);

const isLinkActive = (href: string) => {
  const current = route.path;
  if (href === "/") return current === "/";
  return current.startsWith(href);
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);

  const storedDepts = localStorage.getItem("allDepartments");
  if (storedDepts) allDepartments.value = JSON.parse(storedDepts);

  axios.get(`${url}/departments`).then((r) => {
    allDepartments.value = r.data;
    localStorage.setItem("allDepartments", JSON.stringify(r.data));
  }).catch(console.error);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const computedLinks = computed(() => [
  { text: "Home", href: "/" },
  { text: "About", href: "/about" },
  { text: "Documents", href: "/general-documents" },
  {
    text: "Departments",
    href: "/departments",
    children: allDepartments.value.map((dept: any) => ({
      text: dept.name,
      href: `/departments/${encryptString(dept.id.toString())}`,
    })),
  },
  {
    text: "Projects",
    href: "/projects",
    children: [
      { text: "Ongoing Projects", href: "/ongoing-projects" },
      { text: "Finished Projects", href: "/finished-projects" },
      { text: "Upcoming Projects", href: "/upcoming-projects" },
    ],
  },
  {
    text: "Media",
    href: "/media",
    children: [
      { text: "News", href: "/all-news" },
      { text: "Gallery", href: "/gallery" },
    ],
  },
  { text: "Contact", href: "/contact" },
]);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass(["bg-white border-b border-gray-200 transition-shadow duration-300", isScrolled.value ? 'shadow-md' : ''])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "flex items-center gap-3 flex-shrink-0"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _createElementVNode("nav", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedLinks), (link) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: link.href
              }, [
                (!link.children || link.children.length === 0)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: link.href,
                      class: _normalizeClass(["px-3 py-2 text-sm font-medium uppercase tracking-wide transition-colors", isLinkActive(link.href)
                ? 'text-[#6CC551] border-b-2 border-[#6CC551]'
                : 'text-[#3a3838] hover:text-[#6CC551]'])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "relative",
                      onMouseenter: ($event: any) => (activeDropdown.value = link.text),
                      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (activeDropdown.value = null))
                    }, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["flex items-center gap-1 px-3 py-2 text-sm font-medium uppercase tracking-wide transition-colors", activeDropdown.value === link.text || isLinkActive(link.href)
                  ? 'text-[#6CC551]'
                  : 'text-[#3a3838] hover:text-[#6CC551]'])
                      }, [
                        _createTextVNode(_toDisplayString(link.text) + " ", 1),
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass(["w-3.5 h-3.5 transition-transform duration-200", activeDropdown.value === link.text ? 'rotate-180' : '']),
                          fill: "currentColor",
                          viewBox: "0 0 20 20"
                        }, _hoisted_9, 2))
                      ], 2),
                      _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-150",
                        "enter-from-class": "opacity-0 translate-y-1",
                        "enter-to-class": "opacity-100 translate-y-0",
                        "leave-active-class": "transition ease-in duration-100",
                        "leave-from-class": "opacity-100 translate-y-0",
                        "leave-to-class": "opacity-0 translate-y-1"
                      }, {
                        default: _withCtx(() => [
                          (activeDropdown.value === link.text)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _hoisted_12,
                                  _createElementVNode("p", _hoisted_13, _toDisplayString(link.text), 1)
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.children, (child) => {
                                    return (_openBlock(), _createBlock(_component_router_link, {
                                      key: child.href,
                                      to: child.href,
                                      class: _normalizeClass(["group flex items-center gap-3 px-4 py-2.5 text-sm text-gray-300 hover:text-white hover:bg-white/5 transition-colors relative text-left", isLinkActive(child.href) ? 'text-[#6CC551]' : '']),
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (activeDropdown.value = null))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-4 bg-[#6CC551] rounded-full transition-opacity duration-150", isLinkActive(child.href) ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'])
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(child.text), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "class"]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ], 40, _hoisted_7))
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileOpen.value = !mobileOpen.value)),
              class: "md:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors",
              "aria-label": "Toggle menu"
            }, [
              (!mobileOpen.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                : (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
            ])
          ])
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition ease-out duration-200",
          "enter-from-class": "-translate-y-2 opacity-0",
          "enter-to-class": "translate-y-0 opacity-100",
          "leave-active-class": "transition ease-in duration-150",
          "leave-from-class": "translate-y-0 opacity-100",
          "leave-to-class": "-translate-y-2 opacity-0"
        }, {
          default: _withCtx(() => [
            (mobileOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedLinks), (link) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: link.href
                      }, [
                        (!link.children || link.children.length === 0)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: link.href,
                              class: _normalizeClass(["block px-3 py-2.5 text-sm font-medium uppercase tracking-wide rounded-lg transition-colors", isLinkActive(link.href)
                  ? 'bg-green-50 text-[#6CC551]'
                  : 'text-gray-700 hover:bg-green-50 hover:text-[#6CC551]']),
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (mobileOpen.value = false))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(link.text), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "class"]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (toggleMobileAccordion(link.text)),
                                class: _normalizeClass(["w-full flex items-center justify-between px-3 py-2.5 text-sm font-medium uppercase tracking-wide rounded-lg transition-colors", mobileAccordion.value === link.text
                    ? 'bg-green-50 text-[#6CC551]'
                    : 'text-gray-700 hover:bg-green-50 hover:text-[#6CC551]'])
                              }, [
                                _createTextVNode(_toDisplayString(link.text) + " ", 1),
                                (_openBlock(), _createElementBlock("svg", {
                                  class: _normalizeClass(["w-4 h-4 transition-transform duration-200", mobileAccordion.value === link.text ? 'rotate-180' : '']),
                                  fill: "currentColor",
                                  viewBox: "0 0 20 20"
                                }, _hoisted_28, 2))
                              ], 10, _hoisted_26),
                              _createVNode(_Transition, {
                                "enter-active-class": "transition ease-out duration-150",
                                "enter-from-class": "opacity-0 -translate-y-1",
                                "enter-to-class": "opacity-100 translate-y-0",
                                "leave-active-class": "transition ease-in duration-100",
                                "leave-from-class": "opacity-100 translate-y-0",
                                "leave-to-class": "opacity-0 -translate-y-1"
                              }, {
                                default: _withCtx(() => [
                                  (mobileAccordion.value === link.text)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.children, (child) => {
                                          return (_openBlock(), _createBlock(_component_router_link, {
                                            key: child.href,
                                            to: child.href,
                                            class: _normalizeClass(["group flex items-center gap-3 px-4 py-2.5 text-sm text-gray-300 hover:text-white hover:bg-white/5 transition-colors text-left", isLinkActive(child.href) ? 'text-[#6CC551]' : '']),
                                            onClick: closeMobileNav
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", {
                                                class: _normalizeClass(["w-1 h-3.5 rounded-full bg-[#6CC551] flex-shrink-0 transition-opacity duration-150", isLinkActive(child.href) ? 'opacity-100' : 'opacity-30 group-hover:opacity-100'])
                                              }, null, 2),
                                              _createTextVNode(" " + _toDisplayString(child.text), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to", "class"]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                      ], 64))
                    }), 128)),
                    _hoisted_30
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _hoisted_31
  ], 64))
}
}

})